export default "__VITE_ASSET__nhlkowkG__"